export default "__VITE_ASSET__WUj9jSW___"